import TKTable from '@tk/components/tk.table';
import render from '@tk/utilities/tk.render';

export default class GTATable extends TKTable {
    isStickyRight: boolean;
    stickyCols: number;
    stickyRightClassname: string;
    stickyRightBorderClassname: string;
    leftShadowClassName: string;
    tableCols: HTMLElement[][];

    constructor() {
        super();
        // #region sticky right
        this.isStickyRight = this.hasAttribute('data-tk-is-sticky-right');
        this.stickyCols = parseInt(this.getAttribute('data-tk-is-sticky-right') || '1', 10);
        this.stickyRightClassname = this.getAttribute('data-tk-sticky-right-class-name') || 'tk-table--sticky-right';
        this.stickyRightBorderClassname = (this.getAttribute('data-tk-sticky-right-border-class-name')
            || 'tk-table--sticky-right-border');
        this.leftShadowClassName = this.getAttribute('data-tk-left-shadow-class-name') || 'tk-table__left-shadow';
        this.tableCols = [];
        // #endregion
    }

    connectedCallback() {
        super.connectedCallback();
        // #region Hide empty table cols
        const dataContentCheckArray = this.getEmptyTableCols();
        this.hideEmptyTableCols(dataContentCheckArray);
        // #endregion

        // #region handle eqal cols
        const colsWithEqualValuesCheckArray = this.getColsWithEqualValues();
        const handleColValuesArray = this.checkColsWithEqualValues(colsWithEqualValuesCheckArray);
        this.handleColsWithEqualValues(handleColValuesArray);
        // #endregion

        // #region sticky right
        if (this.isStickyRight) {
            // this.classList.add(this.stickyRightClassname);
            this.setStickyCols();
            this.toggleScrollRightBehavior();
        }
        // #endregion
    }

    // #region Hide empty table cols

    /**
     * �berpr�ft ob alle Zellen einer Spalte leer sind.
     * Dazu wird mit den Zelleninhalten ein array bef�llt.
     * Dann wird pro Zeile gepr�ft, ob in der Spalte ein
     * Wert dazu gekommen ist
     */
    getEmptyTableCols() {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');

        const tableRows = tableBody?.querySelectorAll('tr');

        const dataContentCheckArray: string [] = [];
        tableRows?.forEach((tableRow, tableRowIndex) => {
            const tableCols = tableRow.querySelectorAll('td');
            tableCols.forEach((tableCol, tableColIndex) => {
                let tableCellContent = (tableCol.children[1] as HTMLElement)?.innerText || '';
                tableCellContent = (tableCol.children.length > 1) && (tableCol.children[1].nodeName !== 'SPAN')
                    ? 'ACTION' : tableCellContent;
                if (tableRowIndex === 0) {
                    // Vergeleichsarray bef�llen
                    dataContentCheckArray.push(tableCellContent);
                } else {
                    // Pr�fen ob ein Wert dazu kommt
                    dataContentCheckArray[tableColIndex] = dataContentCheckArray[tableColIndex] || tableCellContent;
                }
            });
        });

        return dataContentCheckArray;
    }

    hideEmptyTableCols(dataContentCheckArray: string []) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        const tableHead = this.table?.querySelector('[data-tk-table-head]');

        // remove table head elements
        const tableHeadRows = tableHead?.querySelectorAll('tr');
        tableHeadRows?.forEach((tableRow) => {
            const tableHeadCells = tableRow.querySelectorAll('td');
            tableHeadCells.forEach((tableHeadCell, tableCellIndex) => {
                if (dataContentCheckArray[tableCellIndex] === '') {
                    tableHeadCell.remove();
                }
            });
        });

        // remove table body elements
        const tableBodyRows = tableBody?.querySelectorAll('tr');
        tableBodyRows?.forEach((tableRow) => {
            const tableBodyCells = tableRow.querySelectorAll('td');
            tableBodyCells.forEach((tableBodyCell, tableCellIndex) => {
                if (dataContentCheckArray[tableCellIndex] === '') {
                    tableBodyCell.remove();
                }
            });
        });

        // set grid-template-columns style attribute
        (window.viewport.clientWidth >= this.desktopMinWidth) && this.setGrid();

        // Debug
        // console.log('dataContentCheckArray: ', dataContentCheckArray);
    }
    // #endregion

    // #region sticky right
    registerScrollListener() {
        super.registerScrollListener();

        if (this.isStickyRight) {
            const handleStickyRightListener = this.toggleScrollRightBehavior.bind(this);
            this.pushListener({
                event: 'scroll',
                element: this,
                action: handleStickyRightListener,
            });
        }
    }

    toggleScrollRightBehavior(event?: Event) {
        let element: HTMLElement;

        if (event) element = event.target as HTMLElement;
        else element = this as HTMLElement;

        const isAtScrollEnd = element.scrollLeft + element.clientWidth + 1 >= element.scrollWidth;

        this.toggelStickyBorder(isAtScrollEnd);
    }

    // #region sticky cols
    setStickyCols(isAtScrollEnd = false) {
        if (this.stickyCols > 1) {
            const rows = this.querySelectorAll('tr');
            rows.forEach((row) => this.tableCols.push([...row.querySelectorAll('td')]));

            this.tableCols.forEach((row) => {
                let sticky = true;
                let offset = 0;
                row.reverse().forEach((col, index) => {
                    if (sticky) {
                        col.classList.toggle(this.stickyRightClassname, !isAtScrollEnd);
                        col.style.right = `${offset}px`;
                        offset += col.offsetWidth;
                    }

                    if (index === this.stickyCols - 1) {
                        sticky = false;
                    }
                });
            });
            this.toggelStickyBorder(isAtScrollEnd);
        } else {
            this.classList.toggle(this.stickyRightClassname, !isAtScrollEnd);
        }
    }

    toggelStickyBorder(isAtScrollEnd: boolean) {
        this.tableCols.forEach((row) => {
            row[this.stickyCols - 1].classList.toggle(this.stickyRightBorderClassname, !isAtScrollEnd);
        });
    }
    // #endregion

    setHorizontalScrollShadow() {
        const className = this.isStickyRight ? this.leftShadowClassName : this.rightShadowClassName;
        this.horizontalScrollShadowElement = render(`<div class='${className}'></div>`);
        if (!this.horizontalScrollShadowElement) return;
        const shadowElementPosition = this.isStickyRight ? 'afterbegin' : 'beforeend';
        this.insertAdjacentElement(shadowElementPosition, this.horizontalScrollShadowElement);
    }

    toggleScrollHorizontalBehavior(event: Event) {
        if (!this.horizontalScrollShadowElement) return;
        const { scrollLeft, scrollWidth, clientWidth } = event.target as HTMLElement;

        if (this.isStickyRight) {
            this.horizontalScrollShadowElement.style.left = `${scrollLeft}px`;
            this.horizontalScrollShadowElement.hidden = scrollLeft === 0;
        } else {
            this.horizontalScrollShadowElement.style.right = `-${scrollLeft}px`;
            this.horizontalScrollShadowElement.hidden = scrollLeft >= scrollWidth - clientWidth;
        }
    }

    handleResize(entries: ResizeObserverEntry[]) {
        entries.forEach(() => {
            this.isHorizontalScrollable = this.scrollWidth > this.clientWidth;
            if (this.isHorizontalScrollable && !this.horizontalScrollShadowElement) {
                this.setHorizontalScrollShadow();
            }
            if (!this.horizontalScrollShadowElement) return;
            this.horizontalScrollShadowElement.hidden = !this.isHorizontalScrollable;
            this.boxShadowElement && (this.boxShadowElement.style.width = `${this.scrollWidth}px`);
        });
    }

    setGrid() {
        const tableHead = this.table?.querySelector('[data-tk-table-head]');

        // remove table head elements
        const tableHeadRow = tableHead?.querySelector('tr');
        if (!tableHeadRow) throw new Error('missing table head');
        const cols = tableHeadRow.childElementCount;
        this.gridTemplateColList = this.customCols?.split(/(?!, ),/g);
        this.style.gridTemplateColumns = this.customCols?.includes(',')
            ? this.gridTemplateColList?.join(' ')
            : `repeat(${cols}, ${this.customCols})`;
        if (this.headElement) {
            this.headElement.classList.remove('tk-table__head--force-mobile');
        }

        const titleElements = this.table?.querySelectorAll('[data-tk-table-body] .tk-table__title');
        if (!titleElements) return;
        titleElements.forEach((titleElement) => {
            (titleElement as HTMLSpanElement).classList.remove('tk-table__title--force-mobile');
        });
    }
    // #endregion

    // #region handle eqal cols
    /**
     * �berpr�ft ob der Inhalt bei allen Zellen einer Spalte gleich ist.
     * Dazu wird mit den Zelleninhalten ein array bef�llt.
     * Dann wird pro Zeile gepr�ft, ob in der Inhalt mit demjenigen der
     * vorherigen Zelle �bereinstimmt. Dies gilt aber nur f�r Zellen vom Typ
     * span, damit nicht versehentlich Buttons ausgebelendet werden
     */
    getColsWithEqualValues() {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');

        const tableRows = tableBody?.querySelectorAll('tr');

        const colsWithEqualValuesCheckArray: string [] = [];
        tableRows?.forEach((tableRow, tableRowIndex) => {
            const tableCols = tableRow.querySelectorAll('td');
            tableCols.forEach((tableCol, tableColIndex) => {
                let tableCellContent = (tableCol.children[1] as HTMLElement)?.innerText || '';
                tableCellContent = (tableCol.children.length > 1) && (tableCol.children[1].nodeName !== 'SPAN')
                    ? 'ACTION' : tableCellContent;
                if (tableRowIndex === 0) {
                    // Vergeleichsarray bef�llen
                    colsWithEqualValuesCheckArray.push(tableCellContent);
                } else {
                    // Pr�fen ob der Wert konstant geblieben ist, falls nicht wird das Array-Feld durch einen Leerstring ersetzt
                    colsWithEqualValuesCheckArray[tableColIndex] = (
                        (colsWithEqualValuesCheckArray[tableColIndex] === tableCellContent)
                        && (tableCellContent !== 'ACTION')
                    ) ? tableCellContent : '';
                }
            });
        });

        // Debug
        // console.log('colsWithEqualValuesCheckArray: ', colsWithEqualValuesCheckArray);
        return colsWithEqualValuesCheckArray;
    }

    /**
     * Es werden nur Spalten behandelt, die das Attribut data-tk-diff-attr besitzen
     * Die anderen Spalten werden nicht angepasst, auch wenn immer der gleiche Wert vorkommt
     * Von der Funktion wird ein Array zur�ckgegeben. In diesem Array steht nur bei jenen
     * Spalten ein Wert, bei denen alle Werte gleich waren und die speziell behandelt werden sollen
    */
    checkColsWithEqualValues(colsWithEqualValuesCheckArray: string []) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');

        const firstRow = tableBody?.querySelector('tr:first-of-type');
        const cells = firstRow?.querySelectorAll('td');
        /**
         * Pr�fen der ersten Zeile des Table-Bodys auf data-tk-diff-attr
         * Falls nicht vorhanden wird der Wert der entsprechenden Spalte
         * von colsWithEqualValuesCheckArray druch einen Leerstring ersetzt.
         * Am Ende stehen im colsWithEqualValuesCheckArray nur doch die Werte derer
         * Spalten, die �berall gleich sind und auch speziell behandelt werden sollen
        */
        const handleColValuesArray: string [] = [];
        cells?.forEach((cell, columnIndex) => {
            const handleEqualColValue = cell.hasAttribute('data-tk-diff-attr');
            const currentColValue = handleEqualColValue ? colsWithEqualValuesCheckArray[columnIndex] : '';
            handleColValuesArray.push(currentColValue);
        });

        // Debug
        // console.log('handleColValuesArray: ', handleColValuesArray);
        return handleColValuesArray;
    }

    /**
     * Mit dieser Funktion werden die 'markierten' Spalten behandelt
     * Bei allen Werten des �bergenen Arrays, bei denen ein Wert vorhanden ist
     * muss eine entsprechende Aktion augef�hrt werden. Diese Aktion wird �ber das
     * Attribut data-tk-eqal-val-action
     * data-tk-eqal-val-action -> remove oder relocate
     * Wurde die Action auf relocate gesetzt, so kann �ber das Data-Attribut
     * data-tk-relocate-selector angegeben werden, wohin die Eintr�ge kopiert werden
     * sollen
     */
    handleColsWithEqualValues(handleColValuesArray: string []) {
        const equalValueAction = this.getAttribute('data-tk-eqal-val-action');
        const relocateSelector = this.getAttribute('data-tk-relocate-selector');
        if (
            !equalValueAction
            || ((equalValueAction === 'relocate') && !relocateSelector)
        ) throw new Error('Missing data attibute');

        const callAction = (equalValueAction === 'remove')
            ? this.removeColsWithEqualValues.bind(this, handleColValuesArray)
            : this.relocateColsWithEqualValues.bind(this, handleColValuesArray);
        callAction();
        // set grid-template-columns style attribute
        (window.viewport.clientWidth >= this.desktopMinWidth) && this.setGrid();
    }

    relocateColsWithEqualValues(handleColValuesArray: string []) {
        const relocateSelector = this.getAttribute('data-tk-relocate-selector');
        const relocateArea = document.querySelector(`[${relocateSelector}]`);
        const relocationAreaClass = this.getAttribute('data-tk-relocate-area-class') || 'tk-table__relocate-area';
        const relocationEntryClass = this.getAttribute('data-tk-relocate-entry-class') || 'tk-table__relocate-entry';
        const relocateLabelClass = this.getAttribute('data-tk-relocate-label-class') || 'tk-table__relocate-label';
        const relocateValueClass = this.getAttribute('data-tk-relocate-value-class') || 'tk-table__relocate-value';
        if (!relocateArea) throw new Error('Missing reloate area');

        relocateArea.classList.add(relocationAreaClass);

        const tableHead = this.table?.querySelector('[data-tk-table-head]');
        const headRow = tableHead?.querySelector('tr:first-of-type');
        const headCells = headRow?.querySelectorAll('td');

        headCells?.forEach((headCell, colIndex) => {
            if (handleColValuesArray[colIndex] !== '') {
                const newEntry = render(`
                    <div class='${relocationEntryClass}'>
                        <span class='${relocateLabelClass}'>${headCell.innerText}</span>
                        <span class='${relocateValueClass}'>${handleColValuesArray[colIndex]}</span>
                    </div>
                `);

                relocateArea.insertAdjacentElement('beforeend', newEntry);
            }
        });

        this.removeColsWithEqualValues(handleColValuesArray);
    }

    removeColsWithEqualValues(handleColValuesArray: string []) {
        const tableBody = this.table?.querySelector('[data-tk-table-body]');
        const tableHead = this.table?.querySelector('[data-tk-table-head]');

        // remove table head elements
        const tableHeadRows = tableHead?.querySelectorAll('tr');
        tableHeadRows?.forEach((tableRow) => {
            const tableHeadCells = tableRow.querySelectorAll('td');
            tableHeadCells.forEach((tableHeadCell, tableCellIndex) => {
                if (handleColValuesArray[tableCellIndex] !== '') {
                    tableHeadCell.remove();
                }
            });
        });

        // remove table body elements
        const tableBodyRows = tableBody?.querySelectorAll('tr');
        tableBodyRows?.forEach((tableRow) => {
            const tableBodyCells = tableRow.querySelectorAll('td');
            tableBodyCells.forEach((tableBodyCell, tableCellIndex) => {
                if (handleColValuesArray[tableCellIndex] !== '') {
                    tableBodyCell.remove();
                }
            });
        });
    }
    // #endregion
}
